/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as Public2faChallengeRouteImport } from './routes/_public/2fa-challenge'
import { Route as AuthenticatedWaitlistRouteImport } from './routes/_authenticated/waitlist'
import { Route as AuthenticatedUsersPermissionsRouteImport } from './routes/_authenticated/users-permissions'
import { Route as AuthenticatedUsersRouteImport } from './routes/_authenticated/users'
import { Route as AuthenticatedTestingRouteImport } from './routes/_authenticated/testing'
import { Route as AuthenticatedSubscriptionsRouteImport } from './routes/_authenticated/subscriptions'
import { Route as AuthenticatedSpecialtiesRouteImport } from './routes/_authenticated/specialties'
import { Route as AuthenticatedSmsRouteImport } from './routes/_authenticated/sms'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedServicesRouteImport } from './routes/_authenticated/services'
import { Route as AuthenticatedSecurityRouteImport } from './routes/_authenticated/security'
import { Route as AuthenticatedScrapingRouteImport } from './routes/_authenticated/scraping'
import { Route as AuthenticatedReferralsRouteImport } from './routes/_authenticated/referrals'
import { Route as AuthenticatedProvidersRouteImport } from './routes/_authenticated/providers'
import { Route as AuthenticatedPricingRouteImport } from './routes/_authenticated/pricing'
import { Route as AuthenticatedPlanWaitlistRouteImport } from './routes/_authenticated/plan-waitlist'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedMedicalRouteImport } from './routes/_authenticated/medical'
import { Route as AuthenticatedMarketingSocialRouteImport } from './routes/_authenticated/marketing-social'
import { Route as AuthenticatedMarketingSettingsRouteImport } from './routes/_authenticated/marketing-settings'
import { Route as AuthenticatedMarketingReadinessRouteImport } from './routes/_authenticated/marketing-readiness'
import { Route as AuthenticatedMarketingLinksRouteImport } from './routes/_authenticated/marketing-links'
import { Route as AuthenticatedMarketingLeadsRouteImport } from './routes/_authenticated/marketing-leads'
import { Route as AuthenticatedMarketingJourneysRouteImport } from './routes/_authenticated/marketing-journeys'
import { Route as AuthenticatedMarketingCampaignsRouteImport } from './routes/_authenticated/marketing-campaigns'
import { Route as AuthenticatedMarketingAdsRouteImport } from './routes/_authenticated/marketing-ads'
import { Route as AuthenticatedMarketingRouteImport } from './routes/_authenticated/marketing'
import { Route as AuthenticatedFeedbackRouteImport } from './routes/_authenticated/feedback'
import { Route as AuthenticatedFeaturesOveragesRouteImport } from './routes/_authenticated/features-overages'
import { Route as AuthenticatedFeaturesAnalyticsRouteImport } from './routes/_authenticated/features-analytics'
import { Route as AuthenticatedFeaturesRouteImport } from './routes/_authenticated/features'
import { Route as AuthenticatedFacilitiesRouteImport } from './routes/_authenticated/facilities'
import { Route as AuthenticatedDsaReportsRouteImport } from './routes/_authenticated/dsa-reports'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedCountriesRouteImport } from './routes/_authenticated/countries'
import { Route as AuthenticatedConsultationPaymentsRouteImport } from './routes/_authenticated/consultation-payments'
import { Route as AuthenticatedClaimsRouteImport } from './routes/_authenticated/claims'
import { Route as AuthenticatedChallengesRouteImport } from './routes/_authenticated/challenges'
import { Route as AuthenticatedBusinessesRouteImport } from './routes/_authenticated/businesses'
import { Route as AuthenticatedBookingRequestsRouteImport } from './routes/_authenticated/booking-requests'
import { Route as AuthenticatedAuditRouteImport } from './routes/_authenticated/audit'
import { Route as AuthenticatedSpecialtiesCountriesRouteImport } from './routes/_authenticated/specialties.countries'
import { Route as AuthenticatedCompliance2faRouteImport } from './routes/_authenticated/compliance.2fa'
import { Route as AuthenticatedBusinessesBusinessIdRouteImport } from './routes/_authenticated/businesses.$businessId'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const Public2faChallengeRoute = Public2faChallengeRouteImport.update({
  id: '/2fa-challenge',
  path: '/2fa-challenge',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedWaitlistRoute = AuthenticatedWaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUsersPermissionsRoute =
  AuthenticatedUsersPermissionsRouteImport.update({
    id: '/users-permissions',
    path: '/users-permissions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersRoute = AuthenticatedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTestingRoute = AuthenticatedTestingRouteImport.update({
  id: '/testing',
  path: '/testing',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSubscriptionsRoute =
  AuthenticatedSubscriptionsRouteImport.update({
    id: '/subscriptions',
    path: '/subscriptions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSpecialtiesRoute =
  AuthenticatedSpecialtiesRouteImport.update({
    id: '/specialties',
    path: '/specialties',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSmsRoute = AuthenticatedSmsRouteImport.update({
  id: '/sms',
  path: '/sms',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedServicesRoute = AuthenticatedServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSecurityRoute = AuthenticatedSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedScrapingRoute = AuthenticatedScrapingRouteImport.update({
  id: '/scraping',
  path: '/scraping',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReferralsRoute = AuthenticatedReferralsRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProvidersRoute = AuthenticatedProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPricingRoute = AuthenticatedPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPlanWaitlistRoute =
  AuthenticatedPlanWaitlistRouteImport.update({
    id: '/plan-waitlist',
    path: '/plan-waitlist',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMedicalRoute = AuthenticatedMedicalRouteImport.update({
  id: '/medical',
  path: '/medical',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMarketingSocialRoute =
  AuthenticatedMarketingSocialRouteImport.update({
    id: '/marketing-social',
    path: '/marketing-social',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMarketingSettingsRoute =
  AuthenticatedMarketingSettingsRouteImport.update({
    id: '/marketing-settings',
    path: '/marketing-settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMarketingReadinessRoute =
  AuthenticatedMarketingReadinessRouteImport.update({
    id: '/marketing-readiness',
    path: '/marketing-readiness',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMarketingLinksRoute =
  AuthenticatedMarketingLinksRouteImport.update({
    id: '/marketing-links',
    path: '/marketing-links',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMarketingLeadsRoute =
  AuthenticatedMarketingLeadsRouteImport.update({
    id: '/marketing-leads',
    path: '/marketing-leads',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMarketingJourneysRoute =
  AuthenticatedMarketingJourneysRouteImport.update({
    id: '/marketing-journeys',
    path: '/marketing-journeys',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMarketingCampaignsRoute =
  AuthenticatedMarketingCampaignsRouteImport.update({
    id: '/marketing-campaigns',
    path: '/marketing-campaigns',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMarketingAdsRoute =
  AuthenticatedMarketingAdsRouteImport.update({
    id: '/marketing-ads',
    path: '/marketing-ads',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMarketingRoute = AuthenticatedMarketingRouteImport.update({
  id: '/marketing',
  path: '/marketing',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFeedbackRoute = AuthenticatedFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFeaturesOveragesRoute =
  AuthenticatedFeaturesOveragesRouteImport.update({
    id: '/features-overages',
    path: '/features-overages',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFeaturesAnalyticsRoute =
  AuthenticatedFeaturesAnalyticsRouteImport.update({
    id: '/features-analytics',
    path: '/features-analytics',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFeaturesRoute = AuthenticatedFeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFacilitiesRoute = AuthenticatedFacilitiesRouteImport.update({
  id: '/facilities',
  path: '/facilities',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDsaReportsRoute = AuthenticatedDsaReportsRouteImport.update({
  id: '/dsa-reports',
  path: '/dsa-reports',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCountriesRoute = AuthenticatedCountriesRouteImport.update({
  id: '/countries',
  path: '/countries',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedConsultationPaymentsRoute =
  AuthenticatedConsultationPaymentsRouteImport.update({
    id: '/consultation-payments',
    path: '/consultation-payments',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClaimsRoute = AuthenticatedClaimsRouteImport.update({
  id: '/claims',
  path: '/claims',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedChallengesRoute = AuthenticatedChallengesRouteImport.update({
  id: '/challenges',
  path: '/challenges',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBusinessesRoute = AuthenticatedBusinessesRouteImport.update({
  id: '/businesses',
  path: '/businesses',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBookingRequestsRoute =
  AuthenticatedBookingRequestsRouteImport.update({
    id: '/booking-requests',
    path: '/booking-requests',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAuditRoute = AuthenticatedAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSpecialtiesCountriesRoute =
  AuthenticatedSpecialtiesCountriesRouteImport.update({
    id: '/countries',
    path: '/countries',
    getParentRoute: () => AuthenticatedSpecialtiesRoute,
  } as any)
const AuthenticatedCompliance2faRoute =
  AuthenticatedCompliance2faRouteImport.update({
    id: '/compliance/2fa',
    path: '/compliance/2fa',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBusinessesBusinessIdRoute =
  AuthenticatedBusinessesBusinessIdRouteImport.update({
    id: '/$businessId',
    path: '/$businessId',
    getParentRoute: () => AuthenticatedBusinessesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/audit': typeof AuthenticatedAuditRoute
  '/booking-requests': typeof AuthenticatedBookingRequestsRoute
  '/businesses': typeof AuthenticatedBusinessesRouteWithChildren
  '/challenges': typeof AuthenticatedChallengesRoute
  '/claims': typeof AuthenticatedClaimsRoute
  '/consultation-payments': typeof AuthenticatedConsultationPaymentsRoute
  '/countries': typeof AuthenticatedCountriesRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/dsa-reports': typeof AuthenticatedDsaReportsRoute
  '/facilities': typeof AuthenticatedFacilitiesRoute
  '/features': typeof AuthenticatedFeaturesRoute
  '/features-analytics': typeof AuthenticatedFeaturesAnalyticsRoute
  '/features-overages': typeof AuthenticatedFeaturesOveragesRoute
  '/feedback': typeof AuthenticatedFeedbackRoute
  '/marketing': typeof AuthenticatedMarketingRoute
  '/marketing-ads': typeof AuthenticatedMarketingAdsRoute
  '/marketing-campaigns': typeof AuthenticatedMarketingCampaignsRoute
  '/marketing-journeys': typeof AuthenticatedMarketingJourneysRoute
  '/marketing-leads': typeof AuthenticatedMarketingLeadsRoute
  '/marketing-links': typeof AuthenticatedMarketingLinksRoute
  '/marketing-readiness': typeof AuthenticatedMarketingReadinessRoute
  '/marketing-settings': typeof AuthenticatedMarketingSettingsRoute
  '/marketing-social': typeof AuthenticatedMarketingSocialRoute
  '/medical': typeof AuthenticatedMedicalRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/plan-waitlist': typeof AuthenticatedPlanWaitlistRoute
  '/pricing': typeof AuthenticatedPricingRoute
  '/providers': typeof AuthenticatedProvidersRoute
  '/referrals': typeof AuthenticatedReferralsRoute
  '/scraping': typeof AuthenticatedScrapingRoute
  '/security': typeof AuthenticatedSecurityRoute
  '/services': typeof AuthenticatedServicesRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/sms': typeof AuthenticatedSmsRoute
  '/specialties': typeof AuthenticatedSpecialtiesRouteWithChildren
  '/subscriptions': typeof AuthenticatedSubscriptionsRoute
  '/testing': typeof AuthenticatedTestingRoute
  '/users': typeof AuthenticatedUsersRoute
  '/users-permissions': typeof AuthenticatedUsersPermissionsRoute
  '/waitlist': typeof AuthenticatedWaitlistRoute
  '/2fa-challenge': typeof Public2faChallengeRoute
  '/login': typeof PublicLoginRoute
  '/businesses/$businessId': typeof AuthenticatedBusinessesBusinessIdRoute
  '/compliance/2fa': typeof AuthenticatedCompliance2faRoute
  '/specialties/countries': typeof AuthenticatedSpecialtiesCountriesRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/audit': typeof AuthenticatedAuditRoute
  '/booking-requests': typeof AuthenticatedBookingRequestsRoute
  '/businesses': typeof AuthenticatedBusinessesRouteWithChildren
  '/challenges': typeof AuthenticatedChallengesRoute
  '/claims': typeof AuthenticatedClaimsRoute
  '/consultation-payments': typeof AuthenticatedConsultationPaymentsRoute
  '/countries': typeof AuthenticatedCountriesRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/dsa-reports': typeof AuthenticatedDsaReportsRoute
  '/facilities': typeof AuthenticatedFacilitiesRoute
  '/features': typeof AuthenticatedFeaturesRoute
  '/features-analytics': typeof AuthenticatedFeaturesAnalyticsRoute
  '/features-overages': typeof AuthenticatedFeaturesOveragesRoute
  '/feedback': typeof AuthenticatedFeedbackRoute
  '/marketing': typeof AuthenticatedMarketingRoute
  '/marketing-ads': typeof AuthenticatedMarketingAdsRoute
  '/marketing-campaigns': typeof AuthenticatedMarketingCampaignsRoute
  '/marketing-journeys': typeof AuthenticatedMarketingJourneysRoute
  '/marketing-leads': typeof AuthenticatedMarketingLeadsRoute
  '/marketing-links': typeof AuthenticatedMarketingLinksRoute
  '/marketing-readiness': typeof AuthenticatedMarketingReadinessRoute
  '/marketing-settings': typeof AuthenticatedMarketingSettingsRoute
  '/marketing-social': typeof AuthenticatedMarketingSocialRoute
  '/medical': typeof AuthenticatedMedicalRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/plan-waitlist': typeof AuthenticatedPlanWaitlistRoute
  '/pricing': typeof AuthenticatedPricingRoute
  '/providers': typeof AuthenticatedProvidersRoute
  '/referrals': typeof AuthenticatedReferralsRoute
  '/scraping': typeof AuthenticatedScrapingRoute
  '/security': typeof AuthenticatedSecurityRoute
  '/services': typeof AuthenticatedServicesRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/sms': typeof AuthenticatedSmsRoute
  '/specialties': typeof AuthenticatedSpecialtiesRouteWithChildren
  '/subscriptions': typeof AuthenticatedSubscriptionsRoute
  '/testing': typeof AuthenticatedTestingRoute
  '/users': typeof AuthenticatedUsersRoute
  '/users-permissions': typeof AuthenticatedUsersPermissionsRoute
  '/waitlist': typeof AuthenticatedWaitlistRoute
  '/2fa-challenge': typeof Public2faChallengeRoute
  '/login': typeof PublicLoginRoute
  '/businesses/$businessId': typeof AuthenticatedBusinessesBusinessIdRoute
  '/compliance/2fa': typeof AuthenticatedCompliance2faRoute
  '/specialties/countries': typeof AuthenticatedSpecialtiesCountriesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_authenticated/audit': typeof AuthenticatedAuditRoute
  '/_authenticated/booking-requests': typeof AuthenticatedBookingRequestsRoute
  '/_authenticated/businesses': typeof AuthenticatedBusinessesRouteWithChildren
  '/_authenticated/challenges': typeof AuthenticatedChallengesRoute
  '/_authenticated/claims': typeof AuthenticatedClaimsRoute
  '/_authenticated/consultation-payments': typeof AuthenticatedConsultationPaymentsRoute
  '/_authenticated/countries': typeof AuthenticatedCountriesRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/dsa-reports': typeof AuthenticatedDsaReportsRoute
  '/_authenticated/facilities': typeof AuthenticatedFacilitiesRoute
  '/_authenticated/features': typeof AuthenticatedFeaturesRoute
  '/_authenticated/features-analytics': typeof AuthenticatedFeaturesAnalyticsRoute
  '/_authenticated/features-overages': typeof AuthenticatedFeaturesOveragesRoute
  '/_authenticated/feedback': typeof AuthenticatedFeedbackRoute
  '/_authenticated/marketing': typeof AuthenticatedMarketingRoute
  '/_authenticated/marketing-ads': typeof AuthenticatedMarketingAdsRoute
  '/_authenticated/marketing-campaigns': typeof AuthenticatedMarketingCampaignsRoute
  '/_authenticated/marketing-journeys': typeof AuthenticatedMarketingJourneysRoute
  '/_authenticated/marketing-leads': typeof AuthenticatedMarketingLeadsRoute
  '/_authenticated/marketing-links': typeof AuthenticatedMarketingLinksRoute
  '/_authenticated/marketing-readiness': typeof AuthenticatedMarketingReadinessRoute
  '/_authenticated/marketing-settings': typeof AuthenticatedMarketingSettingsRoute
  '/_authenticated/marketing-social': typeof AuthenticatedMarketingSocialRoute
  '/_authenticated/medical': typeof AuthenticatedMedicalRoute
  '/_authenticated/notifications': typeof AuthenticatedNotificationsRoute
  '/_authenticated/plan-waitlist': typeof AuthenticatedPlanWaitlistRoute
  '/_authenticated/pricing': typeof AuthenticatedPricingRoute
  '/_authenticated/providers': typeof AuthenticatedProvidersRoute
  '/_authenticated/referrals': typeof AuthenticatedReferralsRoute
  '/_authenticated/scraping': typeof AuthenticatedScrapingRoute
  '/_authenticated/security': typeof AuthenticatedSecurityRoute
  '/_authenticated/services': typeof AuthenticatedServicesRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/sms': typeof AuthenticatedSmsRoute
  '/_authenticated/specialties': typeof AuthenticatedSpecialtiesRouteWithChildren
  '/_authenticated/subscriptions': typeof AuthenticatedSubscriptionsRoute
  '/_authenticated/testing': typeof AuthenticatedTestingRoute
  '/_authenticated/users': typeof AuthenticatedUsersRoute
  '/_authenticated/users-permissions': typeof AuthenticatedUsersPermissionsRoute
  '/_authenticated/waitlist': typeof AuthenticatedWaitlistRoute
  '/_public/2fa-challenge': typeof Public2faChallengeRoute
  '/_public/login': typeof PublicLoginRoute
  '/_authenticated/businesses/$businessId': typeof AuthenticatedBusinessesBusinessIdRoute
  '/_authenticated/compliance/2fa': typeof AuthenticatedCompliance2faRoute
  '/_authenticated/specialties/countries': typeof AuthenticatedSpecialtiesCountriesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/audit'
    | '/booking-requests'
    | '/businesses'
    | '/challenges'
    | '/claims'
    | '/consultation-payments'
    | '/countries'
    | '/dashboard'
    | '/dsa-reports'
    | '/facilities'
    | '/features'
    | '/features-analytics'
    | '/features-overages'
    | '/feedback'
    | '/marketing'
    | '/marketing-ads'
    | '/marketing-campaigns'
    | '/marketing-journeys'
    | '/marketing-leads'
    | '/marketing-links'
    | '/marketing-readiness'
    | '/marketing-settings'
    | '/marketing-social'
    | '/medical'
    | '/notifications'
    | '/plan-waitlist'
    | '/pricing'
    | '/providers'
    | '/referrals'
    | '/scraping'
    | '/security'
    | '/services'
    | '/settings'
    | '/sms'
    | '/specialties'
    | '/subscriptions'
    | '/testing'
    | '/users'
    | '/users-permissions'
    | '/waitlist'
    | '/2fa-challenge'
    | '/login'
    | '/businesses/$businessId'
    | '/compliance/2fa'
    | '/specialties/countries'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/audit'
    | '/booking-requests'
    | '/businesses'
    | '/challenges'
    | '/claims'
    | '/consultation-payments'
    | '/countries'
    | '/dashboard'
    | '/dsa-reports'
    | '/facilities'
    | '/features'
    | '/features-analytics'
    | '/features-overages'
    | '/feedback'
    | '/marketing'
    | '/marketing-ads'
    | '/marketing-campaigns'
    | '/marketing-journeys'
    | '/marketing-leads'
    | '/marketing-links'
    | '/marketing-readiness'
    | '/marketing-settings'
    | '/marketing-social'
    | '/medical'
    | '/notifications'
    | '/plan-waitlist'
    | '/pricing'
    | '/providers'
    | '/referrals'
    | '/scraping'
    | '/security'
    | '/services'
    | '/settings'
    | '/sms'
    | '/specialties'
    | '/subscriptions'
    | '/testing'
    | '/users'
    | '/users-permissions'
    | '/waitlist'
    | '/2fa-challenge'
    | '/login'
    | '/businesses/$businessId'
    | '/compliance/2fa'
    | '/specialties/countries'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_public'
    | '/_authenticated/audit'
    | '/_authenticated/booking-requests'
    | '/_authenticated/businesses'
    | '/_authenticated/challenges'
    | '/_authenticated/claims'
    | '/_authenticated/consultation-payments'
    | '/_authenticated/countries'
    | '/_authenticated/dashboard'
    | '/_authenticated/dsa-reports'
    | '/_authenticated/facilities'
    | '/_authenticated/features'
    | '/_authenticated/features-analytics'
    | '/_authenticated/features-overages'
    | '/_authenticated/feedback'
    | '/_authenticated/marketing'
    | '/_authenticated/marketing-ads'
    | '/_authenticated/marketing-campaigns'
    | '/_authenticated/marketing-journeys'
    | '/_authenticated/marketing-leads'
    | '/_authenticated/marketing-links'
    | '/_authenticated/marketing-readiness'
    | '/_authenticated/marketing-settings'
    | '/_authenticated/marketing-social'
    | '/_authenticated/medical'
    | '/_authenticated/notifications'
    | '/_authenticated/plan-waitlist'
    | '/_authenticated/pricing'
    | '/_authenticated/providers'
    | '/_authenticated/referrals'
    | '/_authenticated/scraping'
    | '/_authenticated/security'
    | '/_authenticated/services'
    | '/_authenticated/settings'
    | '/_authenticated/sms'
    | '/_authenticated/specialties'
    | '/_authenticated/subscriptions'
    | '/_authenticated/testing'
    | '/_authenticated/users'
    | '/_authenticated/users-permissions'
    | '/_authenticated/waitlist'
    | '/_public/2fa-challenge'
    | '/_public/login'
    | '/_authenticated/businesses/$businessId'
    | '/_authenticated/compliance/2fa'
    | '/_authenticated/specialties/countries'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/2fa-challenge': {
      id: '/_public/2fa-challenge'
      path: '/2fa-challenge'
      fullPath: '/2fa-challenge'
      preLoaderRoute: typeof Public2faChallengeRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/waitlist': {
      id: '/_authenticated/waitlist'
      path: '/waitlist'
      fullPath: '/waitlist'
      preLoaderRoute: typeof AuthenticatedWaitlistRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users-permissions': {
      id: '/_authenticated/users-permissions'
      path: '/users-permissions'
      fullPath: '/users-permissions'
      preLoaderRoute: typeof AuthenticatedUsersPermissionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users': {
      id: '/_authenticated/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/testing': {
      id: '/_authenticated/testing'
      path: '/testing'
      fullPath: '/testing'
      preLoaderRoute: typeof AuthenticatedTestingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/subscriptions': {
      id: '/_authenticated/subscriptions'
      path: '/subscriptions'
      fullPath: '/subscriptions'
      preLoaderRoute: typeof AuthenticatedSubscriptionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/specialties': {
      id: '/_authenticated/specialties'
      path: '/specialties'
      fullPath: '/specialties'
      preLoaderRoute: typeof AuthenticatedSpecialtiesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sms': {
      id: '/_authenticated/sms'
      path: '/sms'
      fullPath: '/sms'
      preLoaderRoute: typeof AuthenticatedSmsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/services': {
      id: '/_authenticated/services'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof AuthenticatedServicesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/security': {
      id: '/_authenticated/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof AuthenticatedSecurityRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/scraping': {
      id: '/_authenticated/scraping'
      path: '/scraping'
      fullPath: '/scraping'
      preLoaderRoute: typeof AuthenticatedScrapingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/referrals': {
      id: '/_authenticated/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof AuthenticatedReferralsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/providers': {
      id: '/_authenticated/providers'
      path: '/providers'
      fullPath: '/providers'
      preLoaderRoute: typeof AuthenticatedProvidersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pricing': {
      id: '/_authenticated/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof AuthenticatedPricingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/plan-waitlist': {
      id: '/_authenticated/plan-waitlist'
      path: '/plan-waitlist'
      fullPath: '/plan-waitlist'
      preLoaderRoute: typeof AuthenticatedPlanWaitlistRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications': {
      id: '/_authenticated/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/medical': {
      id: '/_authenticated/medical'
      path: '/medical'
      fullPath: '/medical'
      preLoaderRoute: typeof AuthenticatedMedicalRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/marketing-social': {
      id: '/_authenticated/marketing-social'
      path: '/marketing-social'
      fullPath: '/marketing-social'
      preLoaderRoute: typeof AuthenticatedMarketingSocialRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/marketing-settings': {
      id: '/_authenticated/marketing-settings'
      path: '/marketing-settings'
      fullPath: '/marketing-settings'
      preLoaderRoute: typeof AuthenticatedMarketingSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/marketing-readiness': {
      id: '/_authenticated/marketing-readiness'
      path: '/marketing-readiness'
      fullPath: '/marketing-readiness'
      preLoaderRoute: typeof AuthenticatedMarketingReadinessRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/marketing-links': {
      id: '/_authenticated/marketing-links'
      path: '/marketing-links'
      fullPath: '/marketing-links'
      preLoaderRoute: typeof AuthenticatedMarketingLinksRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/marketing-leads': {
      id: '/_authenticated/marketing-leads'
      path: '/marketing-leads'
      fullPath: '/marketing-leads'
      preLoaderRoute: typeof AuthenticatedMarketingLeadsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/marketing-journeys': {
      id: '/_authenticated/marketing-journeys'
      path: '/marketing-journeys'
      fullPath: '/marketing-journeys'
      preLoaderRoute: typeof AuthenticatedMarketingJourneysRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/marketing-campaigns': {
      id: '/_authenticated/marketing-campaigns'
      path: '/marketing-campaigns'
      fullPath: '/marketing-campaigns'
      preLoaderRoute: typeof AuthenticatedMarketingCampaignsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/marketing-ads': {
      id: '/_authenticated/marketing-ads'
      path: '/marketing-ads'
      fullPath: '/marketing-ads'
      preLoaderRoute: typeof AuthenticatedMarketingAdsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/marketing': {
      id: '/_authenticated/marketing'
      path: '/marketing'
      fullPath: '/marketing'
      preLoaderRoute: typeof AuthenticatedMarketingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/feedback': {
      id: '/_authenticated/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof AuthenticatedFeedbackRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/features-overages': {
      id: '/_authenticated/features-overages'
      path: '/features-overages'
      fullPath: '/features-overages'
      preLoaderRoute: typeof AuthenticatedFeaturesOveragesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/features-analytics': {
      id: '/_authenticated/features-analytics'
      path: '/features-analytics'
      fullPath: '/features-analytics'
      preLoaderRoute: typeof AuthenticatedFeaturesAnalyticsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/features': {
      id: '/_authenticated/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof AuthenticatedFeaturesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/facilities': {
      id: '/_authenticated/facilities'
      path: '/facilities'
      fullPath: '/facilities'
      preLoaderRoute: typeof AuthenticatedFacilitiesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dsa-reports': {
      id: '/_authenticated/dsa-reports'
      path: '/dsa-reports'
      fullPath: '/dsa-reports'
      preLoaderRoute: typeof AuthenticatedDsaReportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/countries': {
      id: '/_authenticated/countries'
      path: '/countries'
      fullPath: '/countries'
      preLoaderRoute: typeof AuthenticatedCountriesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/consultation-payments': {
      id: '/_authenticated/consultation-payments'
      path: '/consultation-payments'
      fullPath: '/consultation-payments'
      preLoaderRoute: typeof AuthenticatedConsultationPaymentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/claims': {
      id: '/_authenticated/claims'
      path: '/claims'
      fullPath: '/claims'
      preLoaderRoute: typeof AuthenticatedClaimsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/challenges': {
      id: '/_authenticated/challenges'
      path: '/challenges'
      fullPath: '/challenges'
      preLoaderRoute: typeof AuthenticatedChallengesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/businesses': {
      id: '/_authenticated/businesses'
      path: '/businesses'
      fullPath: '/businesses'
      preLoaderRoute: typeof AuthenticatedBusinessesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/booking-requests': {
      id: '/_authenticated/booking-requests'
      path: '/booking-requests'
      fullPath: '/booking-requests'
      preLoaderRoute: typeof AuthenticatedBookingRequestsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audit': {
      id: '/_authenticated/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthenticatedAuditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/specialties/countries': {
      id: '/_authenticated/specialties/countries'
      path: '/countries'
      fullPath: '/specialties/countries'
      preLoaderRoute: typeof AuthenticatedSpecialtiesCountriesRouteImport
      parentRoute: typeof AuthenticatedSpecialtiesRoute
    }
    '/_authenticated/compliance/2fa': {
      id: '/_authenticated/compliance/2fa'
      path: '/compliance/2fa'
      fullPath: '/compliance/2fa'
      preLoaderRoute: typeof AuthenticatedCompliance2faRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/businesses/$businessId': {
      id: '/_authenticated/businesses/$businessId'
      path: '/$businessId'
      fullPath: '/businesses/$businessId'
      preLoaderRoute: typeof AuthenticatedBusinessesBusinessIdRouteImport
      parentRoute: typeof AuthenticatedBusinessesRoute
    }
  }
}

interface AuthenticatedBusinessesRouteChildren {
  AuthenticatedBusinessesBusinessIdRoute: typeof AuthenticatedBusinessesBusinessIdRoute
}

const AuthenticatedBusinessesRouteChildren: AuthenticatedBusinessesRouteChildren =
  {
    AuthenticatedBusinessesBusinessIdRoute:
      AuthenticatedBusinessesBusinessIdRoute,
  }

const AuthenticatedBusinessesRouteWithChildren =
  AuthenticatedBusinessesRoute._addFileChildren(
    AuthenticatedBusinessesRouteChildren,
  )

interface AuthenticatedSpecialtiesRouteChildren {
  AuthenticatedSpecialtiesCountriesRoute: typeof AuthenticatedSpecialtiesCountriesRoute
}

const AuthenticatedSpecialtiesRouteChildren: AuthenticatedSpecialtiesRouteChildren =
  {
    AuthenticatedSpecialtiesCountriesRoute:
      AuthenticatedSpecialtiesCountriesRoute,
  }

const AuthenticatedSpecialtiesRouteWithChildren =
  AuthenticatedSpecialtiesRoute._addFileChildren(
    AuthenticatedSpecialtiesRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAuditRoute: typeof AuthenticatedAuditRoute
  AuthenticatedBookingRequestsRoute: typeof AuthenticatedBookingRequestsRoute
  AuthenticatedBusinessesRoute: typeof AuthenticatedBusinessesRouteWithChildren
  AuthenticatedChallengesRoute: typeof AuthenticatedChallengesRoute
  AuthenticatedClaimsRoute: typeof AuthenticatedClaimsRoute
  AuthenticatedConsultationPaymentsRoute: typeof AuthenticatedConsultationPaymentsRoute
  AuthenticatedCountriesRoute: typeof AuthenticatedCountriesRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedDsaReportsRoute: typeof AuthenticatedDsaReportsRoute
  AuthenticatedFacilitiesRoute: typeof AuthenticatedFacilitiesRoute
  AuthenticatedFeaturesRoute: typeof AuthenticatedFeaturesRoute
  AuthenticatedFeaturesAnalyticsRoute: typeof AuthenticatedFeaturesAnalyticsRoute
  AuthenticatedFeaturesOveragesRoute: typeof AuthenticatedFeaturesOveragesRoute
  AuthenticatedFeedbackRoute: typeof AuthenticatedFeedbackRoute
  AuthenticatedMarketingRoute: typeof AuthenticatedMarketingRoute
  AuthenticatedMarketingAdsRoute: typeof AuthenticatedMarketingAdsRoute
  AuthenticatedMarketingCampaignsRoute: typeof AuthenticatedMarketingCampaignsRoute
  AuthenticatedMarketingJourneysRoute: typeof AuthenticatedMarketingJourneysRoute
  AuthenticatedMarketingLeadsRoute: typeof AuthenticatedMarketingLeadsRoute
  AuthenticatedMarketingLinksRoute: typeof AuthenticatedMarketingLinksRoute
  AuthenticatedMarketingReadinessRoute: typeof AuthenticatedMarketingReadinessRoute
  AuthenticatedMarketingSettingsRoute: typeof AuthenticatedMarketingSettingsRoute
  AuthenticatedMarketingSocialRoute: typeof AuthenticatedMarketingSocialRoute
  AuthenticatedMedicalRoute: typeof AuthenticatedMedicalRoute
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRoute
  AuthenticatedPlanWaitlistRoute: typeof AuthenticatedPlanWaitlistRoute
  AuthenticatedPricingRoute: typeof AuthenticatedPricingRoute
  AuthenticatedProvidersRoute: typeof AuthenticatedProvidersRoute
  AuthenticatedReferralsRoute: typeof AuthenticatedReferralsRoute
  AuthenticatedScrapingRoute: typeof AuthenticatedScrapingRoute
  AuthenticatedSecurityRoute: typeof AuthenticatedSecurityRoute
  AuthenticatedServicesRoute: typeof AuthenticatedServicesRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedSmsRoute: typeof AuthenticatedSmsRoute
  AuthenticatedSpecialtiesRoute: typeof AuthenticatedSpecialtiesRouteWithChildren
  AuthenticatedSubscriptionsRoute: typeof AuthenticatedSubscriptionsRoute
  AuthenticatedTestingRoute: typeof AuthenticatedTestingRoute
  AuthenticatedUsersRoute: typeof AuthenticatedUsersRoute
  AuthenticatedUsersPermissionsRoute: typeof AuthenticatedUsersPermissionsRoute
  AuthenticatedWaitlistRoute: typeof AuthenticatedWaitlistRoute
  AuthenticatedCompliance2faRoute: typeof AuthenticatedCompliance2faRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAuditRoute: AuthenticatedAuditRoute,
  AuthenticatedBookingRequestsRoute: AuthenticatedBookingRequestsRoute,
  AuthenticatedBusinessesRoute: AuthenticatedBusinessesRouteWithChildren,
  AuthenticatedChallengesRoute: AuthenticatedChallengesRoute,
  AuthenticatedClaimsRoute: AuthenticatedClaimsRoute,
  AuthenticatedConsultationPaymentsRoute:
    AuthenticatedConsultationPaymentsRoute,
  AuthenticatedCountriesRoute: AuthenticatedCountriesRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedDsaReportsRoute: AuthenticatedDsaReportsRoute,
  AuthenticatedFacilitiesRoute: AuthenticatedFacilitiesRoute,
  AuthenticatedFeaturesRoute: AuthenticatedFeaturesRoute,
  AuthenticatedFeaturesAnalyticsRoute: AuthenticatedFeaturesAnalyticsRoute,
  AuthenticatedFeaturesOveragesRoute: AuthenticatedFeaturesOveragesRoute,
  AuthenticatedFeedbackRoute: AuthenticatedFeedbackRoute,
  AuthenticatedMarketingRoute: AuthenticatedMarketingRoute,
  AuthenticatedMarketingAdsRoute: AuthenticatedMarketingAdsRoute,
  AuthenticatedMarketingCampaignsRoute: AuthenticatedMarketingCampaignsRoute,
  AuthenticatedMarketingJourneysRoute: AuthenticatedMarketingJourneysRoute,
  AuthenticatedMarketingLeadsRoute: AuthenticatedMarketingLeadsRoute,
  AuthenticatedMarketingLinksRoute: AuthenticatedMarketingLinksRoute,
  AuthenticatedMarketingReadinessRoute: AuthenticatedMarketingReadinessRoute,
  AuthenticatedMarketingSettingsRoute: AuthenticatedMarketingSettingsRoute,
  AuthenticatedMarketingSocialRoute: AuthenticatedMarketingSocialRoute,
  AuthenticatedMedicalRoute: AuthenticatedMedicalRoute,
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,
  AuthenticatedPlanWaitlistRoute: AuthenticatedPlanWaitlistRoute,
  AuthenticatedPricingRoute: AuthenticatedPricingRoute,
  AuthenticatedProvidersRoute: AuthenticatedProvidersRoute,
  AuthenticatedReferralsRoute: AuthenticatedReferralsRoute,
  AuthenticatedScrapingRoute: AuthenticatedScrapingRoute,
  AuthenticatedSecurityRoute: AuthenticatedSecurityRoute,
  AuthenticatedServicesRoute: AuthenticatedServicesRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedSmsRoute: AuthenticatedSmsRoute,
  AuthenticatedSpecialtiesRoute: AuthenticatedSpecialtiesRouteWithChildren,
  AuthenticatedSubscriptionsRoute: AuthenticatedSubscriptionsRoute,
  AuthenticatedTestingRoute: AuthenticatedTestingRoute,
  AuthenticatedUsersRoute: AuthenticatedUsersRoute,
  AuthenticatedUsersPermissionsRoute: AuthenticatedUsersPermissionsRoute,
  AuthenticatedWaitlistRoute: AuthenticatedWaitlistRoute,
  AuthenticatedCompliance2faRoute: AuthenticatedCompliance2faRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PublicRouteChildren {
  Public2faChallengeRoute: typeof Public2faChallengeRoute
  PublicLoginRoute: typeof PublicLoginRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  Public2faChallengeRoute: Public2faChallengeRoute,
  PublicLoginRoute: PublicLoginRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
